import type { AnyRouter } from '@tanstack/react-router';
import type { AnalyticsRouteContext } from './analytics-events.js';

/**
 * Derives the ambient analytics context from the router's currently matched
 * leaf route: the org name and revision id path params, when present.
 *
 * @param router - The router whose current matches are read.
 * @returns The route-derived context; absent params are omitted.
 */
export function getRouteAnalyticsContext(router: AnyRouter): AnalyticsRouteContext {
	const matches = router.state.matches;
	const leaf = matches[matches.length - 1];
	if (!leaf) {
		return {};
	}

	const params = leaf.params as Record<string, string | undefined>;
	return {
		...(typeof params['orgName'] === 'string' ? { org_name: params['orgName'] } : {}),
		...(typeof params['revisionId'] === 'string' ? { revision_id: params['revisionId'] } : {}),
	};
}
